function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.823 1.795a.606.606 0 00-.857-.002l-4.602 4.583-1.33-1.33a.606.606 0 00-.856 0L2.784 10.44a.606.606 0 10.857.857l4.965-4.965 1.33 1.329a.606.606 0 00.855 0l5.03-5.01a.606.606 0 00.002-.856z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.374 13.333H1.212V.606A.606.606 0 100 .606v13.333c0 .335.271.606.606.606h14.768a.606.606 0 100-1.212zM15.394 1.596h-4.546a.606.606 0 100 1.212h3.94v3.94a.606.606 0 101.212 0V2.201a.606.606 0 00-.606-.606z"
});

function SvgChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    fill: "currentColor"
  }, props), _ref, _ref2);
}

export default SvgChart;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/chart.svg
// module id = 1286
// module chunks = 10